module.exports = __webpack_public_path__ + "img/receivecoinicon.3657a4f8.svg";